import { z } from "zod";

/** Every failure the API returns has this shape, so the site can always explain it. */
export const problemCodes = [
  "bad_request",
  "unauthorised",
  "not_found",
  "conflict",
  "rate_limited",
  "challenge_failed",
  "contact_not_configured",
  "unavailable",
  "internal",
] as const;

export const problemSchema = z.object({
  error: z.object({
    code: z.enum(problemCodes),
    message: z.string(),
    fields: z.record(z.string(), z.array(z.string())).optional(),
  }),
});

export type ProblemCode = (typeof problemCodes)[number];
export type Problem = z.infer<typeof problemSchema>;
